import styled from 'styled-components'

import { CommentItemSkeleton } from '@root/entities/comment/ui'

import type { ClassNameProps } from '@root/shared/react'
import type { InfoIntent } from '@root/shared/ui-kit'

export type CommentsThreadLoadingProps = {
  intent?: InfoIntent
  description?: string
} & ClassNameProps

export const CommentsThreadLoading = ({
  className,
}: CommentsThreadLoadingProps) => (
  <Root className={className}>
    <CommentItemSkeleton />
    <CommentItemSkeleton />
    <CommentItemSkeleton />
  </Root>
)

const Root = styled.div`
  display: grid;
  border-top: 1px solid var(--background-3);

  padding-inline: 18px;
  padding-top: 12px;

  gap: 10px;
`
